import {Tooltip} from "antd";
import {InfoCircleOutlined} from "@ant-design/icons";

const FormLabel = ({label, tooltip}) => (
  <div style={{display: "flex", gap: 4, alignItems: "center", marginBottom: 6}}>
    <span style={{fontWeight: 500, fontSize: "14px", color: "#262626"}}>{label}</span>
    {tooltip && (
      <Tooltip title={tooltip}>
        <InfoCircleOutlined style={{marginLeft: 8, color: "#bfbfbf", fontSize: "12px", cursor: "help"}} />
      </Tooltip>
    )}
  </div>
);

export default FormLabel;
